<div class="parameter-delete-blocked-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon class="trash-icon">delete</mat-icon>
      <h2>{{ 'Delete Parameter' | translate }}</h2>
    </div>
    <button mat-icon-button (click)="onClose()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content" mat-dialog-content>
    <!-- Parameter Info Card -->
    <div class="parameter-card">
      <div class="card-icon">
        <mat-icon>sensors</mat-icon>
      </div>
      <div class="card-info">
        <h3 class="param-name">{{ data.parameter.analyteName }}</h3>
        @if (data.parameter.type || data.parameter.averagingType) {
          <p class="param-description">
            @if (data.parameter.type) {
              <span>{{ data.parameter.type }}</span>
            }
            @if (data.parameter.averagingType) {
              <span> • {{ data.parameter.averagingType }}</span>
            }
            @if (data.parameter.averagingTimeSeconds) {
              <span> ({{ (data.parameter.averagingTimeSeconds / 60) | number: '1.0-0' }} min)</span>
            }
          </p>
        }
      </div>
    </div>

    <!-- Warning Alert -->
    <div class="warning-alert">
      <mat-icon class="warning-icon">warning</mat-icon>
      <div class="alert-content">
        <h4 class="alert-title">{{ 'Cannot Delete — In Use' | translate }}</h4>
        <p class="alert-message">
          {{ 'This parameter is linked to' | translate }}
          <strong>{{ sensorCount }} {{ sensorCount === 1 ? ('sensor assignment' | translate) : ('sensor assignments' | translate) }}</strong>
          {{ 'and cannot be deleted. Remove all sensor assignments for this parameter first.' | translate }}
        </p>
      </div>
    </div>

    <!-- Linked Sensors Section -->
    @if (!isLoading && linkedSensors.length > 0) {
      <div class="linked-sensors-section">
        <h4 class="section-title">{{ 'LINKED SENSOR ASSIGNMENTS' | translate }} ({{ sensorCount }})</h4>
        <div class="sensors-list">
          @for (sensor of linkedSensors; track sensor) {
            <div class="sensor-item">
              <div class="sensor-info">
                <div class="sensor-icon">
                  <mat-icon>router</mat-icon>
                </div>
                <div class="sensor-details">
                  <p class="sensor-name">{{ sensor.sensorName }}</p>
                  @if (sensor.location) {
                    <p class="sensor-location">{{ sensor.location }}</p>
                  }
                </div>
              </div>
              <div class="sensor-status" [class.active]="sensor.status === 'Active'">
                {{ sensor.status || ('Active' | translate) }}
              </div>
            </div>
          }
        </div>
        <!-- Navigation Link -->
        <div class="navigation-hint">
          <p>
            {{ 'Navigate to' | translate }}
            <a href="javascript:void(0)" (click)="navigateToSensorAssignments()" class="link">
              {{ 'Sensor Assignments' | translate }}
            </a>
            {{ 'to remove or re-map these sensors before deleting this parameter.' | translate }}
          </p>
        </div>
      </div>
    }

    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{ 'Loading sensor assignments...' | translate }}</p>
      </div>
    }

    <!-- Error State -->
    @if (loadError && !isLoading) {
      <div class="error-state">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <p class="error-message">{{ 'Unable to load sensor assignment details. Contact support if this issue persists.' | translate }}</p>
      </div>
    }
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer" mat-dialog-actions>
    <button
      type="button"
      class="btn btn-secondary"
      (click)="onClose()"
      >
      {{ 'Close' | translate }}
    </button>
  </div>
</div>
